module.exports = __webpack_public_path__ + "static/media/ness-logo.1e83c311.png";